import { glossaryData } from 'data/glossary/glossaryData';
import React from 'react';
import { useNavigate } from 'react-router-dom';

const IRISGlossaryTable = () => {
  const navigate = useNavigate();

  const containerStyle = {
    maxWidth: '1200px',
    margin: '0 auto',
    padding: '32px 24px',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    backgroundColor: '#ffffff',
    color: '#1a1a1a',
    lineHeight: '1.6',
  };

  const backButtonStyle = {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '8px',
    padding: '10px 20px',
    backgroundColor: 'transparent',
    border: '1px solid #0d47a1',
    borderRadius: '6px',
    color: '#0d47a1',
    fontWeight: '500',
    fontSize: '1rem',
    cursor: 'pointer',
    transition: 'all 0.2s ease',
    marginBottom: '32px',
  };

  const headerStyle = {
    marginBottom: '32px',
  };

  const logoContainer = {
    display: 'flex',
    alignItems: 'baseline',
    gap: '16px',
    marginBottom: '8px',
  };

  const logoStyle = {
    fontSize: '2.6rem',
    fontWeight: '800',
    color: '#f57c00',
    letterSpacing: '-1px',
  };

  const titleStyle = {
    margin: 0,
    fontSize: '2rem',
    fontWeight: '700',
    color: '#0d47a1',
  };

  const subtitleStyle = {
    color: '#555',
    fontSize: '1.1rem',
    marginTop: '4px',
  };

  const tableContainerStyle = {
    borderRadius: '8px',
    boxShadow: '0 4px 16px rgba(0,0,0,0.08)',
    border: '1px solid #e0e0e0',
    overflow: 'hidden',
    height: '70vh',           // ← Adjustable height (you can use 80vh, 600px, etc.)
    display: 'flex',
    flexDirection: 'column',
  };

  const tableStyle = {
    width: '100%',
    borderCollapse: 'collapse',
    fontSize: '0.98rem',
    tableLayout: 'fixed',
  };

  const theadStyle = {
    backgroundColor: '#0d47a1',
    color: 'white',
    position: 'sticky',
    top: 0,
    zIndex: 10,
  };

  const thStyle = {
    padding: '16px 20px',
    textAlign: 'left',
    fontWeight: '600',
    borderBottom: '2px solid #003087',
  };

  const scrollableBodyStyle = {
    overflowY: 'auto',
    flex: 1,
    scrollBehavior: 'smooth',     // Smooth scrolling when using anchor links or JS
  };

  const tdKeyStyle = {
    backgroundColor: '#fff3e0',
    fontWeight: '600',
    color: '#e65100',
    padding: '16px 20px',
    width: '28%',
    borderBottom: '1px solid #ffe0b2',
    verticalAlign: 'top',
  };

  const tdValueStyle = {
    padding: '16px 20px',
    backgroundColor: '#fafafa',
    borderBottom: '1px solid #e0e0e0',
    verticalAlign: 'top',
  };

  const linkStyle = {
    color: '#0d47a1',
    textDecoration: 'none',
    borderBottom: '1px solid #0d47a1',
  };

  return (
    <div style={containerStyle}>
      {/* Back Button */}
      <button
        onClick={() => navigate('/reporting/iris/iris-giin-compliance-matrix/iris-system-kpi-proj-entities',
            { replace: true }
        )}
        style={backButtonStyle}
        onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = '#e3f2fd')}
        onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = 'transparent')}
      >
        ← Back to IRIS 5.3a Overview
      </button>

      <header style={headerStyle}>
        <div style={logoContainer}>
          <div style={logoStyle}>IRIS+</div>
          <h1 style={titleStyle}>IRIS 5.3a Glossary Terms</h1>
        </div>
        <p style={subtitleStyle}>
          Key definitions used throughout the IRIS 5.3a Catalog of Metrics
        </p>
      </header>

      <div style={tableContainerStyle}>
        <table style={tableStyle}>
          <thead style={theadStyle}>
            <tr>
              <th style={{ ...thStyle, width: '28%' }}>5.3a Term</th>
              <th style={thStyle}>5.3a Definition</th>
            </tr>
          </thead>
        </table>

        <div style={scrollableBodyStyle}>
          <table style={tableStyle}>
            <tbody>
              {glossaryData.map((item, index) => (
                <tr key={index}>
                  <td style={tdKeyStyle}>{item.term}</td>
                  <td style={tdValueStyle}>{item.definition}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default IRISGlossaryTable;